import { Select } from "antd";
import { useState } from "react";

import { getIntValue } from "@/utilities/number";

import ModalScrollableChoices from "./ModalScrollableChoices";

import "./ModalChoices.style.less";

const ModalChoices = ({
  choices = [],
  value = "",
  onChange = () => {},
  ...rest
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Select
        {...rest}
        value={getIntValue(value)} // placeholder only appears when value is undefined
        styles={{ popup: { root: { display: "none" } } }} // we only want the dropdown "input like" look & feel
        onOpenChange={() => setIsModalOpen(true)}
        onClear={() => onChange(undefined)}
        allowClear={true}
        options={choices.map(({ name, value }) => ({
          label: name,
          value: getIntValue(value),
        }))}
      />

      {isModalOpen && (
        <ModalScrollableChoices
          value={value}
          choices={choices}
          onChange={onChange}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};

export default ModalChoices;
